import { useFormik } from 'formik'
import React, { useEffect } from 'react'
import { getUserId } from '../../helpers/auth'
import * as Yup from 'yup'
import Loader from '../../pages/pages/loader'
import { CardBody, CardFooter, CardHeader } from '../other/card/card'
import { Input, Select } from 'antd'
import {
  useCreateDomainsXpathMutation,
  useUpdateDomainsXpathByIdMutation
} from '../../redux/apis/domainsManagement/xpath/dMDomainsXpathApiSlice'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

const DomainXpathEdit = ({ id, xpath }) => {
  let navigate = useNavigate()
  const [
    create,
    { isLoading: createLoading, error: createError, createIsSuccess }
  ] = useCreateDomainsXpathMutation()

  const [update, { isLoading: updateLoading, error: updateError, isSuccess }] =
    useUpdateDomainsXpathByIdMutation()

  const validation = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: true,
    initialValues: {
      search_url: xpath?.search_url,
      search_url_with_pagination: xpath?.search_url_with_pagination,
      max_pagination: xpath?.max_pagination || null,
      search_item_xpath: xpath?.search_item_xpath,
      seasons_links_xpath: xpath?.seasons_links_xpath,
      season_detection_xpath: xpath?.season_detection_xpath,
      season_episode_link_xpath: xpath?.season_episode_link_xpath,
      switch_tabs: xpath?.switch_tabs || 1,
      direct_link_to_watch_servers: xpath?.direct_link_to_watch_servers,
      click_to_access_watch_servers_xpath:
        xpath?.click_to_access_watch_servers_xpath,
      delay_time_after_click: xpath?.delay_time_after_click || 5,
      delay_time_after_click_download_link_xpath:
        xpath?.delay_time_after_click_download_link_xpath || 5,
      watch_servers_xpath: xpath?.watch_servers_xpath,
      follow_download_links: xpath?.follow_download_links || false,
      download_servers_xpath: xpath?.download_servers_xpath,
      direct_link_to_download_servers: xpath?.direct_link_to_download_servers,
      click_to_access_download_servers_xpath:
        xpath?.click_to_access_download_servers_xpath,
      switch_download_tabs: xpath?.switch_download_tabs || '1',
      download_link_xpath: xpath?.download_link_xpath,
      iframe_xpath: xpath?.iframe_xpath || '//iframe',
      domain: id,
      last_updated_by_id: getUserId()
    },

    validationSchema: Yup.object({
      search_url: Yup.string().required('Please Enter Search Url'),
      search_item_xpath: Yup.string().required(
        'Please enter search item xpath'
      ),
      delay_time_after_click: Yup.string().required('Please choose delay time'),
      switch_tabs: Yup.string().required('Please enter number of switch tabs'),
      iframe_xpath: Yup.string().required('Please enter iframe xpath'),
      follow_download_links: Yup.string().required(
        'Please choose follow download links value'
      ),
      delay_time_after_click_download_link_xpath: Yup.string()
        .trim()
        .when('follow_download_links', {
          is: (val) => val === true,
          then: schema => schema.required('Please choose delay time'),
          otherwise: schema => schema.nullable()
        }),

      switch_download_tabs: Yup.string()
        .trim()
        .when('follow_download_links', {
          is: (val) => val === true,
          then: schema =>
            schema.required('Please enter number of switch download tabs'),
          otherwise: schema => schema.nullable()
        }),

      seasons_links_xpath: Yup.string().nullable(),
      season_detection_xpath: Yup.string().nullable(),
      season_episode_link_xpath: Yup.string().nullable(),
      direct_link_to_watch_servers: Yup.string().nullable(),
      click_to_access_watch_servers_xpath: Yup.string().nullable(),
      watch_servers_xpath: Yup.string().nullable(),
      download_servers_xpath: Yup.string().nullable(),
      direct_link_to_download_servers: Yup.string().nullable(),
      click_to_access_download_servers_xpath: Yup.string().nullable(),
      download_link_xpath: Yup.string().nullable(),
      search_url_with_pagination: Yup.string().nullable(),
      max_pagination: Yup.number().nullable()
    }),

    onSubmit: async values => {
      console.log('first')
      try {
        if (xpath == null) {
          const res = await create(values).unwrap()
          navigate(`/domains/domains-info`)
        } else {
          await update({ id: xpath?.id, body: values }).unwrap()
          navigate(`/domains/domains-info`)
        }
      } catch (error) {
        console.error(error)
      }
    }
  })
  useEffect(() => {
    if (updateError?.data) {
      const errorMessages = updateError.data.errors.map(error => error.message)
      errorMessages.forEach(message => {
        toast.error(message)
      })
    } else if (createError?.data) {
      const errorMessages = createError.data.errors.map(error => error.message)

      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [updateError, createError])

  useEffect(() => {
    if (isSuccess) {
      toast.success('Domain xpath Saved successfully!')
    } else if (createIsSuccess) {
      toast.success('Domain xpath Created successfully!')
    }
  }, [createIsSuccess, isSuccess])
  console.log(validation.errors.search_url)
  return (
    <>
      <Loader isLoading={createLoading || updateLoading} />
      <CardHeader>
        {' '}
        {xpath == null ? 'CREATE DOMAIN XPATH' : 'EDIT DOMAIN XPATH'}
      </CardHeader>
      <CardBody>
        <div className='flex w-full flex-col '>
          <div className=' mb-3 flex-1 customInput'>
            <label className="form-label">Search Url</label>
            <Input
              type='text'
              name='search_url'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.search_url}
            />
            {validation.touched.search_url && validation.errors.search_url ? (
              <p className='text-danger'>{validation.errors.search_url}</p>
            ) : null}
          </div>
          <div className=' mb-3 flex-1 customInput'>
            <label className="form-label">Search Url With Pagination</label>
            <Input
              type='text'
              name='search_url_with_pagination'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.search_url_with_pagination}
            />
            {validation.touched.search_url_with_pagination &&
            validation.errors.search_url_with_pagination ? (
              <p className='text-danger'>
                {validation.errors.search_url_with_pagination}
              </p>
            ) : null}
          </div>
          <div className=' mb-3 flex-1 customInput'>
            <label className="form-label">Maximum number of pagination</label>
            <Input
              type='text'
              name='max_pagination'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.max_pagination}
            />
            {validation.touched.max_pagination &&
            validation.errors.max_pagination ? (
              <p className='text-danger'>{validation.errors.max_pagination}</p>
            ) : null}
          </div>
          <div className=' mb-3 flex-1 customInput'>
            <label className="form-label">Search Item Xpath</label>
            <Input
              type='text'
              name='search_item_xpath'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.search_item_xpath}
            />
            {validation.touched.search_item_xpath &&
            validation.errors.search_item_xpath ? (
              <p className='text-danger'>
                {validation.errors.search_item_xpath}
              </p>
            ) : null}
          </div>

          <div className=' mb-3 flex-1'>
            <label>Does Domain Has Seasons?</label>
            <br />
            <Select
              className={'customSelect'}
              name='is_season'
              style={{
                width: '100%'
              }}
              defaultValue={validation?.values?.is_season}
              value={validation?.values?.is_season}
              onChange={e => validation.setFieldValue('is_season', e)}
              onBlur={validation.handleBlur}
              options={[
                {
                  label: 'Yes',
                  value: true
                },
                {
                  label: 'No',
                  value: false
                }
              ]}
            />
            {validation.touched.is_season && validation.errors.is_season ? (
              <p className='text-danger'>{validation.errors.is_season}</p>
            ) : null}
          </div>
          {validation.values.is_season && (
            <>
              <div className=' mb-3 flex-1 customInput'>
                <label className="form-label">Seasons Links Xpath</label>
                <Input
                  type='text'
                  name='seasons_links_xpath'
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.seasons_links_xpath}
                />
                {validation.touched.seasons_links_xpath &&
                validation.errors.seasons_links_xpath ? (
                  <p className='text-danger'>
                    {validation.errors.seasons_links_xpath}
                  </p>
                ) : null}
              </div>
              <div className=' mb-3 flex-1 customInput'>
                <label className="form-label">Seasons Detection Xpath</label>
                <Input
                  type='text'
                  name='season_detection_xpath'
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.season_detection_xpath}
                />
                {validation.touched.season_detection_xpath &&
                validation.errors.season_detection_xpath ? (
                  <p className='text-danger'>
                    {validation.errors.season_detection_xpath}
                  </p>
                ) : null}
              </div>
              <div className=' mb-3 flex-1 customInput'>
                <label className="form-label">Seasons Episode Links Xpath</label>
                <Input
                  type='text'
                  name='season_episode_link_xpath'
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.season_episode_link_xpath}
                />
                {validation.touched.season_episode_link_xpath &&
                validation.errors.season_episode_link_xpath ? (
                  <p className='text-danger'>
                    {validation.errors.season_episode_link_xpath}
                  </p>
                ) : null}
              </div>
            </>
          )}
          <div className=' mb-3 flex-1 customInput'>
            <label className="form-label">Direct Link To Watch Servers</label>
            <Input
              type='text'
              name='direct_link_to_watch_servers'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.direct_link_to_watch_servers}
            />
            {validation.touched.direct_link_to_watch_servers &&
            validation.errors.direct_link_to_watch_servers ? (
              <p className='text-danger'>
                {validation.errors.direct_link_to_watch_servers}
              </p>
            ) : null}
          </div>
          <div className=' mb-3 flex-1 customInput'>
            <label className="form-label">Watch Button Xpath</label>
            <Input
              type='text'
              name='click_to_access_watch_servers_xpath'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.click_to_access_watch_servers_xpath}
            />
            {validation.touched.click_to_access_watch_servers_xpath &&
            validation.errors.click_to_access_watch_servers_xpath ? (
              <p className='text-danger'>
                {validation.errors.click_to_access_watch_servers_xpath}
              </p>
            ) : null}
          </div>
          <div className=' mb-3 flex-1 customInput'>
            <label className="form-label">Delay Time After Clicking Watch Button</label>
            <Input
              type='text'
              name='delay_time_after_click'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.delay_time_after_click}
            />
            {validation.touched.delay_time_after_click &&
            validation.errors.delay_time_after_click ? (
              <p className='text-danger'>
                {validation.errors.delay_time_after_click}
              </p>
            ) : null}
          </div>
          <div className=' mb-3 flex-1 customInput'>
            <label className="form-label">Number Of Switch Tab</label>
            <Input
              type='text'
              name='switch_tabs'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.switch_tabs}
            />
            {validation.touched.switch_tabs && validation.errors.switch_tabs ? (
              <p className='text-danger'>{validation.errors.switch_tabs}</p>
            ) : null}
          </div>
          <div className=' mb-3 flex-1 customInput'>
            <label className="form-label">Embed Links Xpath</label>
            <Input
              type='text'
              name='embed_links_xpath'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.embed_links_xpath}
            />
            {validation.touched.embed_links_xpath &&
            validation.errors.embed_links_xpath ? (
              <p className='text-danger'>
                {validation.errors.embed_links_xpath}
              </p>
            ) : null}
          </div>
          <div className=' mb-3 flex-1 customInput'>
            <label className="form-label">Watch Servers Xpath</label>
            <Input
              type='text'
              name='watch_servers_xpath'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.watch_servers_xpath}
            />
            {validation.touched.watch_servers_xpath &&
            validation.errors.watch_servers_xpath ? (
              <p className='text-danger'>
                {validation.errors.watch_servers_xpath}
              </p>
            ) : null}
          </div>
          <div className=' mb-3 flex-1 customInput'>
            <label className="form-label">Iframe Video Xpath</label>
            <Input
              type='text'
              name='iframe_xpath'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.iframe_xpath}
            />
            {validation.touched.iframe_xpath &&
            validation.errors.iframe_xpath ? (
              <p className='text-danger'>{validation.errors.iframe_xpath}</p>
            ) : null}
          </div>
          <div className=' mb-3 flex-1'>
            <label>Second Flow Of Download</label>
            <br />
            <Select
              className={'customSelect'}
              name='follow_download_links'
              style={{
                width: '100%'
              }}
              defaultValue={validation?.values?.follow_download_links}
              value={validation?.values?.follow_download_links}
              onChange={e =>
                validation.setFieldValue('follow_download_links', e)
              }
              onBlur={validation.handleBlur}
              options={[
                {
                  label: 'Yes',
                  value: true
                },
                {
                  label: 'No',
                  value: false
                }
              ]}
            />
            {validation.touched.follow_download_links &&
            validation.errors.follow_download_links ? (
              <p className='text-danger'>
                {validation.errors.follow_download_links}
              </p>
            ) : null}
          </div>
          {validation.values.follow_download_links && (
            <>
              <div className=' mb-3 flex-1 customInput'>
                <label className="form-label">Direct Link To Download Servers</label>
                <Input
                  type='text'
                  name='direct_link_to_download_servers'
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.direct_link_to_download_servers}
                />
                {validation.touched.direct_link_to_download_servers &&
                validation.errors.direct_link_to_download_servers ? (
                  <p className='text-danger'>
                    {validation.errors.direct_link_to_download_servers}
                  </p>
                ) : null}
              </div>
              <div className=' mb-3 flex-1 customInput'>
                <label className="form-label">
                  Click to Access Download Servers Xpath
                </label>
                <Input
                  type='text'
                  name='click_to_access_download_servers_xpath'
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={
                    validation.values.click_to_access_download_servers_xpath
                  }
                />
                {validation.touched.click_to_access_download_servers_xpath &&
                validation.errors.click_to_access_download_servers_xpath ? (
                  <p className='text-danger'>
                    {validation.errors.click_to_access_download_servers_xpath}
                  </p>
                ) : null}
              </div>
              <div className=' mb-3 flex-1 customInput'>
                <label className="form-label">
                  Delay time after click on download server xpath
                </label>
                <Input
                  type='text'
                  name='delay_time_after_click_download_link_xpath'
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={
                    validation.values.delay_time_after_click_download_link_xpath
                  }
                />
                {validation.touched
                  .delay_time_after_click_download_link_xpath &&
                validation.errors.delay_time_after_click_download_link_xpath ? (
                  <p className='text-danger'>
                    {
                      validation.errors
                        .delay_time_after_click_download_link_xpath
                    }
                  </p>
                ) : null}
              </div>
              <div className=' mb-3 flex-1 customInput'>
                <label className="form-label">Switch download tabs</label>
                <Input
                  type='text'
                  name='switch_download_tabs'
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.switch_download_tabs}
                />
                {validation.touched.switch_download_tabs &&
                validation.errors.switch_download_tabs ? (
                  <p className='text-danger'>
                    {validation.errors.switch_download_tabs}
                  </p>
                ) : null}
              </div>
            </>
          )}
          <div className=' mb-3 flex-1 customInput'>
            <label className="form-label">Download links Xpath</label>
            <Input
              type='text'
              name='download_link_xpath'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.download_link_xpath}
            />
            {validation.touched.download_link_xpath &&
            validation.errors.download_link_xpath ? (
              <p className='text-danger'>
                {validation.errors.download_link_xpath}
              </p>
            ) : null}
          </div>
        </div>
      </CardBody>
      <CardFooter>
        <div className='flex justify-end gap-8'>
          <button
            onClick={() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
              validation.handleSubmit()
            }}
            className='btn btn-theme'
          >
            Submit
          </button>
        </div>
      </CardFooter>
    </>
  )
}

export default DomainXpathEdit
